import React from 'react';
import {
	GetMemberProgramQuery,
	ProgramContentItemCategory,
} from 'src/graphqlTypes/catalogServiceTypes';
import { ProgramContentItems } from 'src/components/ProgramDetails/ProgramContentItems';

interface Props {
	programContentItems: GetMemberProgramQuery['memberProgram']['contentItems'];
}

export const TechnologyRequirements: React.FC<Props> = props => {
	const technologyRequirements = props.programContentItems.filter(
		item => item.category === ProgramContentItemCategory.REQUIREMENTS_TECHNOLOGY
	);

	if (technologyRequirements.length === 0) {
		return null;
	}

	return (
		<ProgramContentItems
			ariaLabel='technology requirements'
			contentItems={technologyRequirements}
			sectionTitle='Technology'
		/>
	);
};
